import React, { createContext, useImperativeHandle, useRef, useState } from 'react'
import BaseModal from '@/component/modal/BaseModal.tsx'
import useQueryGetAlertFalldetectionLive from '@/api/notification/getLiveFalldetectionAlert.ts'
import FalldetectionAlertDetail from '@/pages/notification/falldetection/FalldetectionAlertDetail.tsx'
import { isEmptyArray, isNotEmptyArray } from '@/util/array.ts'
import { useTranslation } from 'react-i18next'

export interface IProps {
    className?: string
    refetchAlerts?: () => void
    defaultId?: number
}

export type IFalldetectionLiveAlertContextProps = {
    id?: number
    setId: (id: number) => void
    refetchList: () => void
    refetchAndResetSelection: () => void
}

export const FalldetectionLiveAlertContext = createContext<IFalldetectionLiveAlertContextProps>({
    id: undefined,
    setId: () => {
    },
    refetchList: () => {
    },
    refetchAndResetSelection: () => {
    }
})

const FalldetectionAlertModal = ({ defaultId, refetchAlerts }: IProps, ref: any) => {
    useTranslation()

    const modalRef = useRef<any>()
    const [id, setId] = useState<number>()
    const { data: alerts, refetch: refetchList } = useQueryGetAlertFalldetectionLive(true)

    const refetchAndResetSelection = async () => {
        const { data: resAlerts } = await refetchList()
        setId(undefined)

        const newAlerts = (resAlerts as any)?.falldetections
        if (isEmptyArray(newAlerts)) {
            modalRef.current.close()
            return
        }

        const myAlerts = newAlerts?.filter((item: any) => item?.alert?.isMyTask == true)
        if (myAlerts && isNotEmptyArray(myAlerts)) {
            setId(myAlerts[0].id)
            return
        }

        const notMyAlerts = newAlerts?.filter((item: any) => !item?.alert?.taskManagerAt)
        if (notMyAlerts && isNotEmptyArray(notMyAlerts)) {
            setId(notMyAlerts[0].id)
            return
        }
    }

    useImperativeHandle(ref, () => ({
        show: () => {
            modalRef.current.show()
        },
        close: () => {
            modalRef.current.close()
        }
    }))

    return (
        <FalldetectionLiveAlertContext.Provider value={{ id, setId, refetchList, refetchAndResetSelection }}>
            <BaseModal
                ref={modalRef}
                width={'1200'}
                onOpenCallback={() => {
                    if (id) return
                    if (defaultId) {
                        setId(defaultId)
                    } else if (((alerts as any)?.falldetections?.length || 0) > 0) {
                        setId((alerts as any)?.falldetections[0]!.id)
                    }
                }}
                onCloseCallback={() => {
                    setId(undefined)
                    refetchAlerts && refetchAlerts()
                }}
                showCloseButton={false}>

                <div className={'p-3 sm:p-4 md:p-5 max-h-[90vh] overflow-auto'}>
                    <FalldetectionAlertDetail />
                </div>
            </BaseModal>
        </FalldetectionLiveAlertContext.Provider>

    )
}

export default React.forwardRef(FalldetectionAlertModal)
